app.controller(
    'AdminListUserController', ['$scope', AdminListUserController]
);

function AdminListUserController($scope) {

    $scope.selectedItem = null;
    $scope.listUsers = [
        {
            name : 'Nom - Prénom',
            addressEmail : 'prenom.nom@lvcg.com',
            role : 'Auteur',
            guide : 'Paris',
            lang : 'FR',
            lastConnection : '03/05 à 14h15',
            active : 'Oui'
        },
        {
            name : 'Nom - Prénom',
            addressEmail : 'prenom.nom@lvcg.com',
            role : 'Traducteur',
            guide : 'Rome',
            lang : 'FR',
            lastConnection : 'Hier à 15h08',
            active : 'non'
        },
        {
            name : 'Nom - Prénom',
            addressEmail : 'prenom.nom@lvcg.com',
            role : 'Secrétaire de rédaction',
            guide : 'Tokyo',
            lang : 'FR',
            lastConnection : '03/08 à 11h30',
            active : 'Oui'
        },
        {
            name : 'Nom - Prénom',
            addressEmail : 'prenom.nom@lvcg.com',
            role : 'Auteur',
            guide : 'Bordeaux',
            lang : 'FR',
            lastConnection : '03/05 à 14h15',
            active : 'Oui'
        },
        {
            name : 'Nom - Prénom',
            addressEmail : 'prenom.nom@lvcg.com',
            role : 'Tous',
            guide : 'Tous',
            lang : 'FR',
            lastConnection : 'Hier à 15h08',
            active : 'Oui'
        },
        {
            name : 'Nom - Prénom',
            addressEmail : 'prenom.nom@lvcg.com',
            role : 'Secrétaire de rédaction',
            guide : 'Tokyo',
            lang : 'FR',
            lastConnection : '03/08 à 11h30',
            active : 'Oui'
        },
        {
            name : 'Nom - Prénom',
            addressEmail : 'prenom.nom@lvcg.com',
            role : 'Auteur',
            guide : 'New York',
            lang : 'FR',
            lastConnection : '03/05 à 14h15',
            active : 'non'
        },
        {
            name : 'Nom - Prénom',
            addressEmail : 'prenom.nom@lvcg.com',
            role : 'Traducteur',
            guide : 'Paris',
            lang : 'FR',
            lastConnection : 'Hier à 15h08',
            active : 'Oui'
        },
        {
            name : 'Nom - Prénom',
            addressEmail : 'prenom.nom@lvcg.com',
            role : 'Secrétaire de rédaction',
            guide : 'Tokyo',
            lang : 'FR',
            lastConnection : '03/08 à 11h30',
            active : 'Oui'
        }
    ];

    $scope.showOptions = function(item, $event)
    {
        $event.stopPropagation();
        $scope.selectedItem = $scope.selectedItem == item ? null : item;
    };

    $scope.close = function(){
        $scope.selectedItem = null;
    };
}